const state = {
  ThousandCurrency: false,
}
const getters = {
  getThousandCurrency: state => {
    return state.ThousandCurrency
  }
}
const mutations = {
  setThousandCurrency(state, value) {
    state.ThousandCurrency = value
  }
}
const actions = {
  setThousandCurrency({commit}, value) {
    commit('setThousandCurrency', value)
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/CurrencyInfo.js